var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copyable-text"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('span',{ref:"text"},[_vm._v(_vm._s(_vm.text))]),_c('button',{attrs:{"title":"Copy text"},on:{"click":_vm.copyText}},[_c('i',{staticClass:"gf gf-copy"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }